export type AppTheme = 'light' | 'dark' | 'ocean' | 'pearl' | 'forest' | 'sky';

export const MAIN_LANDING_THEMES: AppTheme[] = ['light', 'sky', 'dark', 'ocean', 'pearl', 'forest'];

export const getStoredMainLandingTheme = (): AppTheme => {
  if (typeof document !== 'undefined') {
    const themedNode = document.querySelector('[class*="bcTheme-"]');
    const classMatch = themedNode?.className?.match(/bcTheme-(light|dark|ocean|pearl|forest|sky)/);
    if (classMatch && MAIN_LANDING_THEMES.includes(classMatch[1] as AppTheme)) {
      return classMatch[1] as AppTheme;
    }

    const dataTheme = document.documentElement.getAttribute('data-theme');
    if (dataTheme === 'dark') {
      return 'dark';
    }
  }

  if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }

  return 'light';
};
